import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0 bg-white letter-spacing chat-card" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "ms-15" }
const _hoisted_5 = { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 d-felx flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "chat-list flex-grow-1" })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('feature.$messages.select_patient_message')), 1 /* TEXT */)
        ])
      ])
    ]),
    _hoisted_6
  ]))
}